export enum FileAction {
    FLAG = 'flag',
    ANALYZE = 'analyze'
}
